import { LocationOption } from "../../../../interface/interface";

export const bedTypeOptions: LocationOption[] = [
    { id: 2, description: "Cama regular" },
    { id: 5, description: "Cuna" },
    { id: 3, description: "Servo cuna" },
    { id: 4, description: "Incubadora" },
];

export function bedMonitorText(interval: number | null | undefined): string {
    if (interval == null || Number.isNaN(interval)) return "-";
    return `${interval} min`;
}
